// Helper function to check if pathname matches submenu path (avoiding overlap between /resignation and /resignation-employee-list)
export const matchesSubmenuPath = (pathname, subPath) => {
  if (!pathname || !subPath) return false;
  const lowerPathname = pathname.toLowerCase();
  const lowerSubPath = subPath.toLowerCase();
  
  // Special handling for resignation paths to avoid overlap
  // If checking for /resignation-employee-list, match it specifically
  if (lowerSubPath.includes('/resignation-employee-list')) {
    return lowerPathname.includes('/resignation-employee-list');
  }
  // If checking for /resignation, ensure it doesn't match /resignation-employee-list
  if (lowerSubPath.includes('/resignation') && !lowerSubPath.includes('/resignation-employee-list')) {
    return lowerPathname.includes('/resignation') && !lowerPathname.includes('/resignation-employee-list');
  }
  
  // Special handling for audit paths to avoid overlap between /audits and /audit-history
  // If checking for /audit-history, match it specifically
  if (lowerSubPath.includes('/audit-history')) {
    return lowerPathname.includes('/audit-history');
  }
  // If checking for /audits, ensure it doesn't match /audit-history
  if (lowerSubPath.includes('/audits') && !lowerSubPath.includes('/audit-history')) {
    return lowerPathname.includes('/audits') && !lowerPathname.includes('/audit-history');
  }
  
  // Special handling for announcement paths to avoid overlap between
  // /engage/announcements, /announcement and /announcement-category.
  // If checking for the Engage module path, match it specifically
  if (lowerSubPath.includes('/engage/announcements')) {
    return lowerPathname.includes('/engage/announcements');
  }
  // If checking for /announcement-category, match it specifically
  if (lowerSubPath.includes('/announcement-category')) {
    return lowerPathname.includes('/announcement-category');
  }
  // If checking for /announcement, ensure it doesn't match /announcement-category or /engage/announcements
  if (lowerSubPath.includes('/announcement') && !lowerSubPath.includes('/announcement-category')) {
    return lowerPathname.includes('/announcement') &&
      !lowerPathname.includes('/announcement-category') &&
      !lowerPathname.includes('/engage/announcements');
  }

  // /skills is a substring of its own sibling paths (/skills-matrix,
  // /skill-inventory, etc.) - without this, the generic `includes` check
  // below would match /skills-matrix against the /skills tab too.
  if (lowerSubPath.endsWith('/skills')) {
    return lowerPathname.endsWith('/skills');
  }

  return lowerPathname.includes(lowerSubPath);
};
